import { Tags } from 'packages/form/entities/legacy/question/Tags';
var prototypes = {
    welcome_screen: [
        {
            name: 'welcome_screen',
            icon: null,
            color: 'color1',
            disabled: false,
            preset: {
                type: 'welcome',
                title: 'form.question_defaults.welcome.title',
                subtitle: 'form.question_defaults.welcome.subtitle',
                description: 'form.question_defaults.welcome.description',
                subtype: null,
                validationRule: ['single'],
            },
        },
    ],
    questions: [
        {
            name: 'open_text',
            icon: 'freeform-text',
            color: 'color3',
            disabled: false,
            preset: {
                label: 'form.question_defaults.open_text',
                type: 'opentext',
                validationRule: ['required'],
            },
        },
        {
            name: 'multiple_choice',
            icon: 'multi-choice',
            color: 'color4',
            disabled: false,
            preset: {
                type: 'select',
                options: [
                    {
                        position: 1,
                    },
                    {
                        position: 2,
                    },
                ],
            },
        },
        {
            name: 'date',
            icon: 'event',
            color: 'color5',
            disabled: false,
            preset: {
                type: 'datetime',
                validationRule: ['required'],
            },
        },
        {
            name: 'yes_no',
            icon: 'single-choice',
            color: 'color6',
            disabled: false,
            preset: {
                type: 'select',
                subtype: 'polar',
                options: [
                    {
                        position: 1,
                        label: 'common.yes',
                    },
                    {
                        position: 2,
                        label: 'common.no',
                    },
                ],
            },
        },
        {
            name: 'email',
            icon: 'at',
            color: 'color7',
            disabled: false,
            preset: {
                type: 'text',
                subtype: 'email',
                validationRule: ['required', 'email'],
            },
        },
        {
            name: 'website',
            icon: 'link-url',
            color: 'color8',
            disabled: false,
            preset: {
                type: 'text',
                subtype: 'website',
                validationRule: ['required', 'url'],
            },
        },
        {
            name: 'text',
            type: 'text',
            icon: 'text-field',
            color: 'color1',
            disabled: false,
            preset: {
                type: 'text',
                validationRule: ['required'],
            },
        },
    ],
    application: [
        {
            name: 'cv',
            icon: 'cv',
            color: 'color2',
            disabled: false,
            preset: {
                type: 'file',
                subtype: 'cv',
                label: 'form.question_defaults.cv',
                tags: { system: ['application', 'respondent_cv'] },
            },
        },
        {
            name: 'avatar',
            icon: 'user-avatar',
            color: 'color14',
            disabled: false,
            preset: {
                type: 'file',
                subtype: 'avatar',
                label: 'form.question_defaults.avatar',
                tags: { system: ['application', 'respondent_avatar'] },
            },
        },
    ],
    contacts: [
        {
            name: 'phone',
            icon: 'phone',
            color: 'color9',
            disabled: false,
            preset: {
                type: 'text',
                subtype: 'phone',
                label: 'form.question_defaults.phone',
                tags: { system: [Tags.CONTACT, Tags.TALENT_PHONE] },
                validationRule: ['required', 'phone', 'single'],
            },
        },
        {
            name: 'name',
            icon: 'pencil',
            color: 'color10',
            disabled: false,
            preset: {
                type: 'text',
                subtype: 'name',
                label: 'form.question_defaults.name',
                tags: { system: [Tags.CONTACT, Tags.TALENT_NAME, Tags.PREFILL_CONFIGURABLE] },
                validationRule: ['required', 'single'],
            },
        },
        {
            name: 'email',
            icon: 'at',
            color: 'color11',
            disabled: false,
            preset: {
                type: 'text',
                subtype: 'email',
                label: 'form.question_defaults.email',
                tags: { system: [Tags.CONTACT, Tags.TALENT_EMAIL, Tags.PREFILL_CONFIGURABLE] },
                validationRule: ['required', 'email', 'single'],
            },
        },
    ],
    final_screen: [
        {
            name: 'final_screen',
            icon: null,
            color: 'color12',
            disabled: false,
            preset: {
                type: 'final-screen',
                title: 'form.question_defaults.result.title',
                description: 'form.question_defaults.result.description',
            },
        },
    ],
};
export function retrievePrototype(name, category) {
    if (category === void 0) { category = 'questions'; }
    return prototypes[category].find(function (prototype) { return prototype.name === name; });
}
export default prototypes;
